import {apiAxios} from "@/service/APIClient";
import PurchaseCreateRequestDTO from "@/models/request/PurchaseCreateRequestDTO";
import PurchaseDTO from "@/models/PurchaseDTO";
import PurchaseCreateResultDTO from "@/models/PurchaseCreateResultDTO";

export const purchases = {
    get: async (id: string): Promise<PurchaseDTO> => {
        let resp = await apiAxios({
            url: `/purchases/${id}`,
            method: 'GET',
        })

        return resp.data as PurchaseDTO
    },
    create: async (requestDTO: PurchaseCreateRequestDTO): Promise<PurchaseCreateResultDTO> => {
        let resp = await apiAxios({
            url: `/purchases`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as PurchaseCreateResultDTO
    },
    complete: async (id: string): Promise<any> => {
        let resp = await apiAxios({
            url: `/purchases/${id}/complete`,
            method: 'PUT',
        })

        return resp.data as any
    },
    cancel: async (id: string): Promise<any> => {
        let resp = await apiAxios({
            url: `/purchases/${id}/cancel`,
            method: 'PUT',
        })

        return resp.data as any
    }
}